import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {WmNotificationService} from "../shared/components/notification/wm-notification.service";
import { HttpErrorResponse } from '@angular/common/http';
import {getRandomUUID} from '../shared/utils/utils';

@Injectable()
export class WebmateErrorHandler implements ErrorHandler {

  /* We cannot use regular DI here, as the ErrorHandler *must* be loaded first.
   * We therefore use the injector class to manually load the required services on demand */
  constructor(private injector: Injector) { }

  private silent: boolean = false;

  handleError(error: Error | HttpErrorResponse) {
    if (!this.silent){
        let nonce = getRandomUUID().substring(0, 5);
        console.error('[ERROR]', nonce, error);
        if (error instanceof HttpErrorResponse) {
            //; TODO get http method?
            // comes from API
            if (error.status === 500) {
                // internal server error
                this.injector.get(WmNotificationService).errorNotification(error.message, nonce);
            } else if (error.status === 401 || error.status === 403) {
                // Auth Error -> Login again
                this.injector.get(WmNotificationService).goToLoginNotification();
            } else if (error.status === 404){
                // This can happen, ignore for now
            } else if (error.status === 504) {
                this.injector.get(WmNotificationService).toastErrorNotification("The request timed out. Please try again later");
            } else {
                // 4XX
                this.injector.get(WmNotificationService).toastErrorNotification(error.message);
            }
        } else {
            // internal (JS, angular, etc.) error
            this.injector.get(WmNotificationService).errorNotification(error.message, nonce);

        }
    }
    // We can either rethrow the error and let angular crash the regular way,
    // or do nothing and handle it ourself.
    // throw error;
  }

  suppressErrors(){
    this.silent = true;
  }

}
